import { render, staticRenderFns } from "./AppointmentPaymentDialog.vue?vue&type=template&id=435c2478"
import script from "./AppointmentPaymentDialog.vue?vue&type=script&lang=ts"
export * from "./AppointmentPaymentDialog.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentPaymentDialog.vue?vue&type=style&index=0&id=435c2478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports